<template>
  <div class="topic-bind-model-edit">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item style="float: left">
          <el-button
            type="primary"
            @click="selModel"
          >{{ $t('dms_topic_bind_model_edit.xuan_ze_wu_mo_xing') }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input
            :placeholder="$t('dms_topic_bind_model_edit.wmxmcwmxdm')"
            v-model="formSearch.search"
            @fetch="keyword = formSearch.search"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <custom-table
      :height="tableHeight"
      :data="filter(tableList)"
      :column="tableColumn"
      :index="true"
      :tree-props="{ children: 'children' }"
      row-key="tslDataId"
      @filter="filterChange"
      @sort="sortChange"
      :slots="[
        'tcpDataCode',
        'topicTslClass',
        'topicTslType',
        'transferType',
        'transferExpression',
        'showOrder',
        'isPrimary',
        'isYearKey',
        'tcpDataLen',
        'tcpDataType',
        'isPushMq',
        'topicTslGroup',
        'tcpTopicTslClass',
        'action',
      ]"
    >
      <template v-slot:tcpTopicTslClass="scope">
        <custom-select
          v-model="scope.row.tcpTopicTslClass"
          code="iot_topic_tsl_class"
          :placeholder="getPlaceholder(scope.$index, formSearch.pageNum)"
        ></custom-select>
      </template>
      <template v-slot:topicTslGroup="scope">
        <custom-select
          v-model="scope.row.topicTslGroup"
          code="iot_topic_tsl_group"
          :filterable="true"
          :placeholder="getPlaceholder(scope.$index, formSearch.pageNum)"
        ></custom-select>
      </template>
      <template v-slot:isPushMq="scope">
        <el-checkbox
          :true-label="1"
          :false-label="0"
          v-model="scope.row.isPushMq"
        ></el-checkbox>
      </template>
      <!-- TSL协议 -->
      <template v-slot:tcpDataCode="scope">
        {{ scope.row.tcpDataCode || '-' }}
      </template>
      <template v-slot:topicTslClass="scope">
        <custom-select
          v-model="scope.row.topicTslClass"
          :code="topicTslClassCode"
          :placeholder="getPlaceholder(scope.$index, formSearch.pageNum)"
        ></custom-select>
      </template>
      <!-- 协议类型 -->
      <template v-slot:tcpDataType="scope">
        {{ getDicValue('iot_tcp_data_type', scope.row.tcpDataType) || '-' }}
      </template>
      <template v-slot:topicTslType="scope">
        <custom-select
          v-model="scope.row.topicTslType"
          :code="tslTypeCode"
        ></custom-select>
      </template>
      <template v-slot:isPrimary="scope">
        <el-checkbox
          :true-label="1"
          :false-label="0"
          v-model="scope.row.isPrimary"
        ></el-checkbox>
      </template>
      <template v-slot:isYearKey="scope">
        <el-checkbox
          :true-label="1"
          :false-label="0"
          v-model="scope.row.isYearKey"
        ></el-checkbox>
      </template>
      <template v-slot:showOrder="scope">
        <el-input
          v-model="scope.row.showOrder"
          :min="0"
          type="number"
        ></el-input>
      </template>
      <!-- 数据转换 -->
      <template v-slot:transferType="scope">
        {{ getDicValue('iot_transfer_type', scope.row.transferType) || '-' }}
      </template>
      <!-- 转换表达式 -->
      <template v-slot:transferExpression="scope">
        {{ scope.row.transferExpression || '-' }}
      </template>
      <!-- 协议长度 -->
      <template v-slot:tcpDataLen="scope">
        {{ scope.row.tcpDataLen || '-' }}
      </template>
      <template v-slot:action="scope">
        <el-button
          v-if="!hasParent(scope.row)"
          type="text"
          size="mini"
          @click="del(scope.row)"
        >{{ $t('Common.com_delete') }}</el-button>
      </template>
    </custom-table>
    <sel-model-dialog
      v-if="showSelModelDialog"
      @close="showSelModelDialog = false"
      :topicId="topicId"
      :protocolCode="protocolCode"
      @confirm="onSelModel"
      :model="dialogModel1"
    ></sel-model-dialog>
    <expression-setting-dialog
      v-if="showExpression"
      @close="showExpression = false"
      :code="expressionCode"
      :expression="expression"
      :model="dialogModel2"
      @confirm="expressionConfirm"
    ></expression-setting-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';
import expressionSettingDialog from '@/pages/dms/product/children/expression_setting_dialog.vue';
import { getTransferRelation, getShowSettingConfig, getShowInputConfig, showRelativeModelConfig } from '@/pages/dms/product/children/utils';
import selModelDialog from './topic_sel_model_dialog.vue';

export default {
  components: {
    selModelDialog,
    expressionSettingDialog,
  },
  props: {
    protocolCode: String,
    topicId: String,
    tableHeight: String,
  },
  data() {
    return {
      tableCode: 'protocol_selected_model',
      showSelModelDialog: false,
      expressionCode: '',
      tslId: '',
      expression: '',
      showExpression: false,
      dialogModel1: {},
      dialogModel2: {},
      // tslType
      formSearch: {
        search: '',
        pageSize: 20,
        pageNum: 1,
        orderType: '',
        orderBy: '',
        tslType: [],
      },
      tableList: [],
      totalRows: null,
      topicTslClassCode: 'iot_topic_tsl_class',
      tslTypeCode: 'iot_topic_tsl_type',
      transferTypeCode: 'iot_transfer_type',
      transferList: [],
      keyword: '',
      /** 无需转化： "0"  值到值："1" 倍率："2" 时间类型："3" 时间格式时分-数字 : "4"   */
      transferRelation: [],
      showInputConfig: {},
      showSettingConfig: {},
    };
  },
  computed: {
  },
  mounted() {
    this.getDictionary('iot_transfer_type_show,iot_transfer_expression_widget', (data) => {
      const transferRelationDic = data.iot_transfer_type_show;
      this.transferRelation = getTransferRelation(transferRelationDic);
      this.showInputConfig = getShowInputConfig(data.iot_transfer_expression_widget);
      this.showSettingConfig = getShowSettingConfig(data.iot_transfer_expression_widget);
    });
    this.getTableColumn();
    this.getDictionary('iot_transfer_type', (dic) => {
      this.transferList = dic.iot_transfer_type;
    });
  },
  methods: {
    selModel() {
      this.showSelModelDialog = true;
      this.dialogModel1 = {
        title: this.$t('dms_topic_bind_model_edit.xuan_ze_wu_mo_xing'),
      };
    },
    showInput(row) {
      return showRelativeModelConfig(row, this.showInputConfig);
    },
    showSetting(row) {
      return showRelativeModelConfig(row, this.showSettingConfig);
    },
    tslClassChange({ topicTslClass }, index) {
      for (let i = 0; i < this.tableList.length; i++) {
        const item = this.tableList[i];
        if (i > index) {
          if (!item.topicTslClass) {
            this.tableList[i].topicTslClass = topicTslClass;
          } else {
            return;
          }
        }
      }
    },
    clearData() {
      this.keyword = '';
      this.tableList = [];
      this.totalRows = null;
      this.formSearch = {
        search: '',
        pageSize: 20,
        pageNum: 1,
        orderType: '',
        orderBy: '',
        tslType: [],
      };
    },
    onCurrentPage() { },
    expressionConfirm(expression) {
      const item = this.tableList.find(obj => obj.tslId === this.tslId);
      if (item) {
        item.transferExpression = expression;
      }
    },
    dataFilter(list, row) {
      const ret = [];
      const typeConfig = this.transferRelation.find(item => item.types.includes(row.dataType));
      const transferList = list;
      transferList.forEach((item) => {
        if (typeConfig.values.includes(item.value)) {
          ret.push(item);
        }
      });
      return ret;
    },
    settingExpression(row) {
      this.expressionCode = row.dicGroup;
      this.expression = row.transferExpression;
      this.dialogModel2.title = this.$t('dms_topic_bind_model_edit.zdzppb');
      this.showExpression = true;
      this.tslId = row.tslId;
    },
    getList() {
      return this.tableList;
    },
    filter(list) {
      const tslType = this.formSearch.tslType || [];
      return list.filter((item) => {
        const { componentName = '', tslName = '' } = item;
        const keywordVal = this.keyword ? componentName.includes(this.keyword) || tslName.includes(this.keyword) : true;
        const tslTypeVal = tslType.length ? tslType.includes(item.tslType) : true;
        return keywordVal && tslTypeVal;
      });
    },
    // 同步子节点数据
    parentPropertyChange(row, property) {
      const val = row[property];
      if (row.children.length) {
        row.children.forEach((item) => {
          item[property] = val;
        });
      }
    },
    hasParent(row) {
      return row.dataParentId !== '0';
    },
    transferTypeChange(row) {
      row.transferExpression = '';
    },
    onSelModel(rows) {
      const newData = rows.filter(item => !this.tableList.some(obj => obj.tslId === item.tslId));
      this.getChildNodes(newData).then(({ data }) => {
        this.fixProperty(data);
        const treeNodes = this.nodeToTree(data);
        this.tableList.push(...treeNodes);
      });
    },
    getChildNodes(list) {
      return this.$getJSON(apis.TslTopicPreAssociateList, {
        tslIds: list.map(item => item.tslId).join(','),
      });
    },
    nodeToTree(list, pid) {
      if (pid === undefined) {
        pid = '0';
      }
      const ret = [];
      list.forEach((item) => {
        if (item.dataParentId === pid) {
          ret.push(item);
        }
      });
      ret.forEach((item) => {
        item.children = this.nodeToTree(list, item.tslDataId);
      });
      return ret;
    },
    del(row) {
      this.tableList = this.tableList.filter(item => item.tslDataId !== row.tslDataId);
    },
    fixProperty(list) {
      const fixArr = [
        'topicTslClass',
        'tcpDataCode',
        'topicTslType',
        'transferType',
        'transferExpression',
        'isPrimary',
        'isYearKey',
        'showOrder',
        'tcpDataLen',
        'tcpDataType',
        'isPushMq',
        'topicTslGroup',
        'tcpTopicTslClass',
      ];
      list.forEach((item) => {
        fixArr.forEach((key) => {
          if (item[key] === undefined) {
            if (key === 'transferType') {
              item[key] = '0';
            } else if (key === 'isPrimary') {
              item[key] = 0;
            } else if (key === 'isYearKey') {
              item[key] = 0;
            } else if (key === 'showOrder') {
              item[key] = 0;
            } else if (key === 'isPushMq') {
              item[key] = 0;
            } else {
              item[key] = '';
            }
          }
        });
      });
    },
    getPlaceholder(index, page) {
      if (page === 1 && index === 0) {
        return this.$t('Common.com_please_select');
      }
      return this.$t('dms_topic_bind_model_edit.mo_ren_tong_shang');
    },
  },
};
</script>

<style lang="scss">
.topic-bind-model-edit {
  .el-table {
    margin-top: 0 !important;
  }
}
</style>
